import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-alert-confirmacao',
  templateUrl: './alert-confirmacao.component.html',
  styleUrls: ['./alert-confirmacao.component.scss']
})
export class AlertConfirmacaoComponent {

  @Input() corPrimaria: string;
  @Input() titulo: string;
  @Input() texto: string;
  @Input() showButtonCancelar: boolean;
  @Input() textoCancelar: string;
  @Input() textoConfirmacao: string;
  @Output() toggle = new EventEmitter();

  constructor() { }

  toggleAlert(confirm: boolean) {
    this.toggle.emit(confirm);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/alert-confirmacao/alert-confirmacao.component.ts